import React, { createContext, useContext, useState, ReactNode } from 'react';
import { toast } from 'react-hot-toast';

interface MovingPlant {
  plantId: string;
  fromSlotId: string;
  fromAreaId: string;
  label: string;
  speciesName?: string;
  fromAreaName?: string;
  fromCoordinates?: {
    row: number;
    col: number;
  };
}

interface MovePlantContextType {
  movingPlant: MovingPlant | null;
  startMove: (plant: MovingPlant) => void;
  cancelMove: () => void;
  isMoving: boolean;
}

const MovePlantContext = createContext<MovePlantContextType | undefined>(undefined);

export const MovePlantProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [movingPlant, setMovingPlant] = useState<MovingPlant | null>(null);

  const startMove = (plant: MovingPlant) => {
    setMovingPlant(plant);
    const sourceLabel = plant.fromCoordinates
      ? `ze slotu [${plant.fromCoordinates.row}, ${plant.fromCoordinates.col}]`
      : 'z vybraného slotu';
    const areaLabel = plant.fromAreaName ? ` v záhonu ${plant.fromAreaName}` : '';

    toast.success(
      `Přesazení připraveno: ${plant.label} ${sourceLabel}${areaLabel}. Vyberte prázdný cílový slot.`,
      { duration: 3500 },
    );
  };

  const cancelMove = () => {
    setMovingPlant(null);
    toast.dismiss();
  };

  const isMoving = !!movingPlant;

  return (
    <MovePlantContext.Provider value={{ movingPlant, startMove, cancelMove, isMoving }}>
      {children}
    </MovePlantContext.Provider>
  );
};

export const useMovePlantContext = () => {
  const context = useContext(MovePlantContext);
  if (context === undefined) {
    throw new Error('useMovePlantContext must be used within a MovePlantProvider');
  }
  return context;
};
